import React from 'react'

import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { SearchModal } from 'src/components/icons'
import { useTranslation } from 'react-i18next'

const InitialState = () => {
  const { t } = useTranslation('common')

  return (
    <Stack flex={1} alignItems="center" justifyContent="center">
      <Stack
        mb={4}
        sx={{
          width: 293,
          height: 110,
        }}
      >
        <SearchModal fontSize={293} />
      </Stack>
      <Typography fontSize={20} color={'grey.900'}>
        {t('whatAreYouSearchingFor')}
      </Typography>
      <Typography fontSize={14} color="grey.900">
        {t('searchForFavoriteThing')}
      </Typography>
    </Stack>
  )
}

export default InitialState
